<template>
  <v-dialog v-model="isOpen" max-width="480" persistent>
    <v-card>
      <v-card-title primary-title dark class="primary white--text">
        Renomear
      </v-card-title>

      <v-card-text class="pt-6">
      <v-text-field label="Novo nome" placeholder="" v-model="newName"/>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancelRenaming">
          Cancelar
        </v-btn>
        <v-btn color="primary" :disabled="!newName.length" @click="confirmRenaming">
          Renomear
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RenamingModal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isOpen: false,
    renamingConfirmed: false,
    newName: '',
  }),
  methods: {
    cancelRenaming() {
      this.isOpen = false;
      this.$emit('close');
    },
    confirmRenaming() {
      this.isOpen = false;
      this.$emit('confirm', this.newName);
      this.newName = '';
    },
  },
  watch: {
    open(newValue) {
      this.isOpen = newValue;
    },
  },
  beforeMount() {
    this.isOpen = this.open;
  },
};
</script>
